import {createSelector} from 'reselect';

export const tokenAuthSelector = createSelector(
    (state) => state.auth,
    app => app.token,
);

export const userRolesSelector = createSelector(
    (state) => state.auth,
    app => app.userRoles,
);

export const profileSelector = createSelector(
    (state) => state.auth,
    app => app.profile,
);

export const roleListrequestSelector = createSelector(
    (state) => state.auth,
    app => app.roleListrequest,
);

export const employeesSelector = createSelector(
    (state) => state.auth,
    auth => auth.accountLists,
);

export const accountWorksSelector = createSelector(
    (state) => state.auth,
    auth => auth.accountWorkLists,
);

export const accountStoresSelector = createSelector(
    (state) => state.auth,
    auth => auth.accountStoreList,
);

export const accountSwitchSelector = createSelector(
  state => state.auth,
  auth => auth.accountSwitch,
);
